module.exports = __webpack_public_path__ + "static/media/reservations-book.a8fecc0b.svg";